const TextField = {
  isComponent: el => el.tagName === 'TEXT-FIELD' ||
    (el.tagName === 'DIV' && el.classList.contains('v-text-field')),
  model: {
    defaults: Object.assign({}, {
      tagName: 'div',
      draggable: true,
      droppable: false,
      copyable: true,
      attributes: {
        id: 'text-field'
      },
      traits: [],
      components: model => `
        <div class="v-input__control">
          <div class="v-input__slot">
            <div class="v-text-field__slot">
              <label for="input-1739" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">Regular</label>
              <input id="input-1739" type="text">
            </div>
          </div>
        </div>
      `
    })
  }
}

export default TextField
